export default __webpack_public_path__ + "static/media/reveal-conversation-grey.c5bb8bc0.svg";